import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';
import { SectionHeader } from 'components/common/override-rates/SectionHeader';

export const ProductLineHeaderStyled = styled.header`
  display: flex;
  justify-content: space-between;
`;

export const OverrideRatesButtonStyled = styled(Button)`
  text-transform: uppercase;
  font-weight: 700;
`;

export const SectionHeaderStyled = styled(SectionHeader)`
  justify-content: center;
`;

export const UWResultsSectionHeaderStyled = styled.header`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 2.4rem 4rem;
  margin-bottom: 2rem;
  font-size: 1.6rem;
  text-align: center;
  font-weight: 500;
  line-height: 2.4rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
`;

export const ResultsCardStyled = styled.div`
  margin: 3rem 0 0;
  padding: 2rem 3rem 3rem;
  border-radius: 1rem;
  background-color: ${colors.neutral.white};

  &:first-of-type {
    margin: 2rem 0 0;
  }
`;
